import { defineStore } from 'pinia'

import { actions } from './actions'
import { createInitialState } from './state'
import { getters } from './getters'

export const useDisciplineStore = defineStore('discipline', {
  state: createInitialState,
  actions,
  getters,
})
